// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"IconSelectorModal_iconContainer__3X8UU","container":"IconSelectorModal_container__3KNcS","selected":"IconSelectorModal_selected__1e02D"};